import React from "react";
import { Link } from "react-router-dom";
import { SOCIALS, NAV_LINKS } from "@/data/site";

const Footer = () => (
  <footer data-testid="site-footer" className="w-full border-t border-hairline bg-white-smoke">
    <div className="mx-auto max-w-[1440px] px-5 py-14 sm:px-8 lg:px-[56px]">
      <div className="mx-auto flex max-w-[1208px] flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div className="flex flex-col gap-3">
          <Link to="/" data-testid="footer-logo-link" className="font-display text-[20px] uppercase tracking-[0.16em] text-ink">
            Stephanie Roxanne
          </Link>
          <p className="max-w-[320px] text-[13.5px] leading-[23px] text-charcoal">
            Faith, Spoken Out Loud. Honest conversations rooted in faith — real testimonies, Jesus, politics, and culture.
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <span className="eyebrow text-[11px] leading-[18px] text-charcoal-mid">Social Media</span>
          <div className="flex flex-col gap-2">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-social-${s.label.toLowerCase()}`}
                className="font-display text-[14px] uppercase tracking-[0.08em] text-charcoal transition-colors hover:text-black"
              >
                {s.label}
              </a>
            ))}
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <span className="eyebrow text-[11px] leading-[18px] text-charcoal-mid">Explore</span>
          <div className="flex flex-col gap-2">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.href}
                to={l.href}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="font-display text-[14px] uppercase tracking-[0.08em] text-charcoal transition-colors hover:text-black"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="mx-auto mt-12 max-w-[1208px] border-t border-hairline pt-6">
        <p className="text-[12.5px] leading-[20px] text-charcoal-mid">
          © 2026 Stephanie Roxanne · Stephanie R. Lamar · All Rights Reserved
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
